import { useEffect } from "react";
import SelectorInit from "./SelectorInit.jsx";
import "../style/initialPage.css";
import { globalT } from "../utils/globalUtils.js";

const InitialPage = (props) => {
  useEffect(() => {
    props.setInit(true);
  }, [props]);

  return (
    <div className="m-initialPage">
      <div className="m-title">{globalT("¡Te damos la bienvenida a RE-Write!")}</div>
      <div className="m-selectors">
        <SelectorInit id="sel-1" m-sel-cont color="#F2E5C6" title={globalT("Géneros textuales")} text={globalT("Aprende con estos géneros textuales, de forma autodidacta")} img="exercices.png" path="/exercices/category/" />
        <SelectorInit
          id="sel-2"
          color="#48935D"
          title={globalT("Autocorrector para la redacción de géneros textuales")}
          text={
            <>
              {`${globalT("Autocorrige tu texto")}. `}
              <div className="m-uned-auth-link">
                {globalT("Se requiere autenticacion UNED")}
              </div>
            </>
          }
          img="genre-writing-checker.png"
          imgClassName="m-genre-writing-checker-icon"
          path="/checker/category/"
        />
        {/* !Aquest selector ha de portar a un form de contacte amb només el contacte de la Silvia? */}
        <SelectorInit id="sel-3" title={globalT("Contáctanos")} text={globalT("Para más información, puedes contactar con nosotros")} img="logo.png" path="/uned-contacto" />
      </div>
    </div>
  );
};

export default InitialPage;
